import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-terminoenvio',
  templateUrl: './ecommerce-terminoenvio.component.html',
  styleUrls: ['./ecommerce-terminoenvio.component.css']
})
export class EcommerceTerminoenvioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
